module.exports = __webpack_public_path__ + "img/icon_zhibozhong.ce8da507.gif";